import React from 'react';
import { FilterStatusesProps } from './filter-statuses.types';
import classes from '../filter-elements.module.scss';
import SearchIcon from '../../../icons-new/search';
import { objectUtility } from '../../../../utils/object/object';
import FilterStatusesGroup from './filter-statuses-group/filter-statuses-group';
import useCheckboxesState from './hooks/use-checkboxes-state';
import useFilteredDropListData from './hooks/use-filtered-drop-list-data';

const FilterStatuses = ({ title, handleInput, dropListData, filterForServer }: FilterStatusesProps) => {
  const { groupedEvents, onChangeHandler, inputValue } = useFilteredDropListData(dropListData);
  const { checkboxesState, updateCheckboxState } = useCheckboxesState({
    dropListData,
    handleInput,
    title,
    filterForServer
  });

  return (
    <div>
      <section className={classes.filter_container}>
        <div className={classes.filter_input_wrapper}>
          <input
            className={classes.input_without_search}
            type='text'
            onChange={onChangeHandler}
            value={inputValue}
            autoFocus
            placeholder={'Text'}
          />

          <div className={classes.search_icon}>
            <SearchIcon width={22} height={22} />
          </div>
        </div>
      </section>

      {objectUtility.entries(groupedEvents).map(([key, value], index) => (
        <FilterStatusesGroup
          key={key + inputValue}
          group={{ title: key, items: value }}
          groupCheckboxState={checkboxesState[key]}
          updateCheckboxState={updateCheckboxState}
          isLastOneGroup={index === objectUtility.entries(groupedEvents).length - 1}
          inputValue={inputValue}
        />
      ))}
    </div>
  );
};

export default FilterStatuses;
